export default {"src":"/_next/static/media/Portainer.4f5be6f9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};